import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './utils/http'
import './assets/iconfont/iconfont.css'
import VueClipBoard from 'vue-clipboard2'

Vue.use(ElementUI)
Vue.use(VueClipBoard)
Vue.config.productionTip = false
Vue.prototype.$http = http

// 静态图片资源域名（名片图片独立域名 yuqiancard.shanshiyidu.com）
Vue.prototype.$baseUrl = 'https://yuqiancard.shanshiyidu.com/images'
// 上传接口使用当前域名相对路径 /api
Vue.prototype.$uploadUrl = '/api/upload/img'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
